export default __webpack_public_path__ + "static/media/icon-lock.5400564a.svg";